import {shallowEqual, useSelector} from 'react-redux';
import {ListBersResult} from '../../graph/ber';
import {AppState} from '../index';

export const useListBersByPage = (page: string): ListBersResult => {
  return useSelector<AppState, ListBersResult>(({bers}) => bers[page] ?? {}, shallowEqual);
};
